var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166687,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2652_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3258 48H28.6591L30.3258 36.3333H24.4924C23.0258 36.3333 23.9424 35.0833 23.9758 35.0333C26.1258 31.2333 29.3591 25.5667 33.6758 18H35.3424L33.6758 29.6667H39.5258C40.1924 29.6667 40.5591 29.9833 40.1924 30.7667C33.6091 42.25 30.3258 48 30.3258 48Z",
    fill: "#043873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2652_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12.1667 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilidad);
export default __webpack_public_path__ + "static/media/agilidad.9e81e5f2665dc440fb5444de2ee3b418.svg";
export { ForwardRef as ReactComponent };